import { ref, readonly, provide, type InjectionKey } from 'vue'
import { v4 as uuid } from 'uuid'

import type { ChangeView, View, ViewOptions, Views } from './types'

export const useViewManager = <T extends View>(views: Views, key?: InjectionKey<ChangeView<T>>) => {
    const currentView = ref<View>(null)
    const currentViewOptions = ref<ViewOptions>({ previousView: null })

    const changeView: ChangeView<T> = async (
        view,
        options = {},
    ) => {
        if (view && !views.includes(view as string)) {
            throw new Error(`unknown view: ${view}`)
        }

        const previousView = currentView.value

        currentViewOptions.value = {
            ...options,
            previousView,
            nonce: uuid(),
        }

        currentView.value = view
    }

    if (key) {
        provide(key, changeView)
    }

    return {
        currentView: readonly(currentView),
        currentViewOptions: readonly(currentViewOptions),
        changeView,
    }
}
